<template>
  <main>
    <top-menu :menu-items="menuItems"/>
    <router-view></router-view>
    <bottom-footer :menu-items="menuItems"/>
  </main>
</template>

<script>
import TopMenu from './components/top-menu.vue'
import BottomFooter from './components/footer.vue'

import information from './configurables/information'

export default {
  name: 'App',
  components: {
    TopMenu,
    BottomFooter
  },
  data () {
    return {
      menuItems: [
        {url: "/", name: 'home'},
        {url: "/takenpakket", name: "takenpakket"},
        {url: "/diensten", name: "diensten"},
        {url: "/downloads", name: "downloads"},
        {url: "/contact", name: "contact"},
      ],
      faviconUrl: './assets/favicon.ico',
    }
  },
  computed: {
    currentRoute() {
      return this.$router.currentRoute.name;
    }
  },
  // metaInfo()  {
  //   return {
  //     title: `${this.currentRoute} - ${information.title}`,
  //     meta: [
  //       { name: 'viewport', content: 'width=device-width, initial-scale=1, user-scalable=0' },
  //       { name: 'description', content: 'Rojeca ADR Advies is uw veiligheidsadviseur ADR voor het transport, de opslag en de verwerking van gevaarlijke stoffen.' }
  //     ],
  //     link: [
  //       {rel: "shortcut icon", type: "ico", href: this.faviconUrl},
  //     ]
  //   }
  // },
}
</script>

<style>
  @import url('https://fonts.googleapis.com/css?family=Titillium+Web:300,400,400i,700&display=swap');
  @import url('https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css');
  @import url('https://fonts.googleapis.com/css?family=Playfair+Display&display=swap');

  :root {
    --primary-color: #498bc9;
    --primary-color-fade: #498bc950;
    --secondary-color: #60bd6e;
    --secondary-color-fade: #60bd6e50;
    --tertiary-color: #f7931d ;
    --tertiary-color-fade: #f7931d50;
    --primary-color-dark: #476275;
    --content-width: 840px;
    --menu-height: 140px;
    --foreground-color: #444;
    --item-margin-large: 32px;
    --item-margin: 16px;
    --item-margin-small: 8px;
    --item-padding-large: 50px;
    --item-padding: 32px;
    --mobile-padding: 40px;
  }

  * {
    font-family: 'Titillium Web', sans-serif;
    font-size: 18px;
  }

  body {
    margin: 0;
    color: var(--foreground-color);
  }

  i.fa {
    font-family: "FontAwesome";
  }

  i.fa.large {
    font-size: 50px;
    margin-bottom: 5px;
  }

  i.fa.medium {
    font-size: 30px;
  }

  i.fa::before {
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    font-weight: 500;
  }

  i.fa.allergies::before { content: "\f007" }
  i.fa.rules::before { content: "\F0CB" }
  i.fa.accident::before { content: "\f071" }
  i.fa.emergency::before { content: "\f0a1" }
  i.fa.download::before { content: "\F0ED" }
  i.fa.arrow::before { content: "\F054" }
  i.fa.hamburger::before { content: "\f0c9" }
  i.fa.times::before { content: "\f00d" }


  p, h1, h2, h3 {
    margin-top: 0px;
  }

  p {
    line-height: 34px;
  }

  p a {
    color: var(--primary-color);
    text-decoration: none;
  }

  p.quote {
    line-height: 40px;
    font-weight: 100;

    border-left: 3px solid var(--secondary-color);
    padding-left: var(--item-margin-large);
    position: relative;
  }

  p.quote::after {
    --size: 40px;
    content: "”";
    font-family: 'Playfair Display', serif;
    position: absolute;
    font-size: 40px;
    text-align: center;
    vertical-align: middle; 
    background: white;
    border-radius: 50%;
    line-height: calc(var(--size) * 1.4);
    width: var(--size);
    height: var(--size);

    left: calc(var(--size) / -2);
    top: calc(50% - var(--size) / 2);
    color: var(--secondary-color);
  }

  .text-center {
    text-align: center;
  }

  .color-white { color: white; }
  .color-primary { color: var(--primary-color);}
  .color-secondary { color: var(--secondary-color);}
  .color-tertiary { color: var(--tertiary-color);}
  .color-primary-dark { color: var(--primary-color-dark);}

  h1 {
    font-size: 26px;
    text-transform: uppercase;
    color: var(--primary-color);
  }

  button {
    padding: 10px 20px;
    margin-bottom: var(--item-margin-large);
    background: var(--primary-color);
    color: white;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    text-transform: uppercase;
  
  }

  button:focus {
    background: var(--primary-color-fade);
    color: var(--primary-color);
    outline: none;
  }

  button:hover {
    opacity: 0.8;
  }

  .content-width {
    width: var(--content-width);
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: var(--item-padding-large) 0;
  }

  p {
    margin-bottom: var(--item-margin);
  }

  .margin-bottom-large {
    margin-bottom: var(--item-margin-large);
  }

  .margin-right { margin-right: var(--item-margin); }
  .margin-right-small { margin-right: var(--item-margin-small); }

  ul.pretty {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0 0 var(--item-margin-large) 0;
    border-left: 5px solid var(--primary-color);
  }
  ul.pretty li {
    list-style: none;
    padding: 8px var(--item-margin);
    display: flex;
  }

  ul.pretty li .name {
    width: 100px;
  }

  ul.pretty li:nth-child(odd) {
    background: #ddd3;
  }

  ul.standout {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0;
    margin: 0 0 var(--item-margin-large) 0;
  }
  ul.standout li {
    list-style: none;
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 3px;
    background: #fff4;

  }

  img.border {
    border: solid 3px #ddd5;
  }

  @media only screen and (max-width: 600px) {
  :root {
    --content-width: calc(100% - var(--mobile-padding));
  }

  html, body {
    overflow-x: hidden;
  }

  * {
    font-size: 16px;
  }
}


</style>


// WEBPACK FOOTER //
// src/app.vue